export default {
  setBlog(state, results) {
    state.blog = results;
  },
  setCourses(state, results) {
    state.courses = results;
  },
  setNews(state, results) {
    state.news = results;
  },
  setProducts(state, results) {
    state.products = results;
  },
  setLessons(state, results) {
    state.lessons = results;
  }
};
